import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-flex-direction-column is-justify-content-center is-align-items-center h-100" }
const _hoisted_2 = {
  key: 0,
  ref: "gauge-wrapper",
  class: "gauge-wrapper"
}
const _hoisted_3 = { ref: "gauge" }
const _hoisted_4 = { class: "gauge-value h-100 w-100 is-flex is-flex-direction-column is-justify-content-center is-align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "elichens elichens-aq-in is-size-4" }, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "is-size-1-fullhd is-size-2-widescreen is-size-3-tablet is-size-desktop co2-value" }
const _hoisted_7 = { class: "is-size-4" }
const _hoisted_8 = {
  key: 1,
  class: "is-size-4 has-text-bold aq-label"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-clock-outline mr-1" }, null, -1 /* HOISTED */)
const _hoisted_11 = {
  key: 3,
  class: "is-flex is-flex-direction-column is-justify-content-center is-align-items-center h-100"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "is-size-2 mdi mdi-emoticon-dead" }, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "is-size-4 w-50 has-text-white" }
const _hoisted_14 = { class: "widget-label" }
const _hoisted_15 = { class: "has-text-white is-size-5 has-text-weight-semibold is-line-height-5" }
const _hoisted_16 = {
  key: 0,
  class: "co2-aqi-ext box"
}
const _hoisted_17 = { class: "has-text-link is-size-7 is-line-height-7" }
const _hoisted_18 = { class: "has-text-link is-size-4 is-line-height-4 barlow has-text-weight-bold" }
const _hoisted_19 = { class: "has-text-link is-size-7 is-line-height-7 is-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    widget: _ctx.widget,
    mode: _ctx.widgetMode,
    class: "is-clipped",
    padding: false,
    isHoverable: true,
    onClick: _ctx.onWidgetClick,
    empty: !_ctx.currentStation
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "wrapper",
        class: _normalizeClass(["co2-wrapper p-2", _ctx.airQualityBackgroundClass])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (!_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, null, 512 /* NEED_PATCH */),
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.co2), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.co2Unit), 1 /* TEXT */)
                ])
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true),
          (!_ctx.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.airQualityLabel), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (!_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(_ctx.lastMeasureDate), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.aq_co2_widget.error')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('indicators.CO2.label')), 1 /* TEXT */)
        ]),
        ((_ctx.aqiExt || _ctx.fake) && !_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("span", {
                class: _normalizeClass(["elichens elichens-aq-out has-text-link is-size-5 is-line-height-5", _ctx.extAirQualityTextColorClass])
              }, null, 2 /* CLASS */),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('dashboard.aq_co2_widget.exterior')), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.aqiExt || 23), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('dashboard.aq_co2_widget.aqi')), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["widget", "mode", "onClick", "empty"]))
}